import { createTheme, MantineColorsTuple } from "@mantine/core";

// Maroon brand ramp carried over from the standalone LMU TV app. Applied via a
// nested <MantineProvider> around the LMUTV route subtree so the hub stays green.
const lmuTVColors: MantineColorsTuple = [
  "#fff0ee",
  "#fbd9d6",
  "#f1b1ab",
  "#e8867d",
  "#e16157",
  "#dd4a3f",
  "#dc3d31",
  "#c32f24",
  "#ae271d",
  "#99180d",
];

export const lmuTvTheme = createTheme({
  primaryColor: "lmuTVColors",
  colors: { lmuTVColors },
});
